/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

import {ListFieldComponent} from './list-field.component';

@Component({
  selector: 'gp-form-field-trans-id-list',
  template: `
    <ng-select class="form-control"
               [(ngModel)]="value.transId"
               [attr.test-id]="descriptor.zoneID"
               (ngModelChange)="onValueChange($event)"
               [formControl]="control"
               [idField]="'display'"
               [textField]="'display'"
               (focus)="onFocus()"
               (blur)="onBlur()"
               [readOnly]="readOnly"
               [items]="items$ | async"
               [sortByTranslationsEnabled]=false
               [parentScrollSelector]="parentScrollSelector">
    </ng-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransIdListFieldComponent extends ListFieldComponent implements OnInit {

  constructor(protected translateService: TranslateService,
              protected cd: ChangeDetectorRef) {
    super(translateService, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public onValueChange(value: any) {
    if (value) {
      const listItem: any = this.descriptor.metadatas.items.find((item: any) => item.display === value);
      if (listItem) {
        this.value.value = listItem.value;
        this.value.transId = listItem.display;
      }
    } else {
      this.value.value = null;
      this.value.transId = null;
    }
  }

}
